import React from 'react'
import styles from './Bio.module.css'
import { getGravatarURL } from '../utils/getGravatarURL'
import biopic from '../biopic.jpeg'

function Bio(props) {
  let photoURL = getGravatarURL({
    email: "test1@example.com",
    size: 56,
  })

  return (
    <div className={`
      ${styles.Bio}
      ${props.className || ''}
    `}>
    <img src={biopic} className={styles["image"]} alt="Miles Garnsey" />
      <p>
        A blog about data science/engineering, machine learning, AI and distributed systems. 
        <br />
        By{' '} <a href="https://twitter.com/MilesGarnsey/">Miles Garnsey</a>.
        <br />
        <i>Managing Director @ Atreus Technologies, Engineering @ another place. </i>
        <br />
        For questions, feedback, or work (the latter preferred) contact me on {' '}
        <a href="https://twitter.com/MilesGarnsey/">Twitter</a>, <a href="https://hachyderm.io/@milesgarnsey">Mastodon</a>,
        or catch me on {' '}
        <a href="https://www.linkedin.com/in/miles-garnsey-b283403b/">LinkedIn</a>.
        <br />
      </p>
    </div>
  )
}

export default Bio
